// Adds a shadow class to scrollable content to show that the element is scrollable

/**
 * Adds a subtle inset shadow to scrollable elements to easily indicate to the user 
 * that the element is scrollable. 
 * 
 * The scrollable element must have a wrapper to which these styles are applied (.js-nav-mobile-scroll-wrapper)
 * 
 * This helper uses the before & after pseudo elements on the wrapper so those can't be used for anything else. 
 * 
 * The helper also listens to a 'appeal-scroll-update' custom event, which you can fire if you make any manual
 * changes to the layout that affects the scroll height of the element. You can fire it like this: 
 * 
 *    document.dispatchEvent(new CustomEvent('appeal-scroll-update'));
 * 
 * You may need to wrap this in a 'setTimeout' if the update is called before the layout is updated. 
 * 
 * This is currently only configured to do horizontal scrolling, though vertical scrolling would be pretty easy to implement. 
 */


const ScrollShadow = {
  _selectors: {
    wrapperEl: '.js-nav-mobile-scroll-wrapper',
    contentEl: '.js-nav-mobile-scroll-element'
  },

  _modifiers: {
    shadowTop: 'scroll-shadow--top',
    shadowBottom: 'scroll-shadow--bottom',
  },

  contentScrollHeight: 0,

  init() {
    const wrapperElement = document.querySelector(this._selectors.wrapperEl);
    const scrollElement = document.querySelector(this._selectors.contentEl);
    
    if (scrollElement === undefined || wrapperElement === undefined) {
      return;
    }

    wrapperElement.classList.add('scroll-shadow');

    scrollElement.addEventListener('scroll', () => {
      this.toggleScrollShadows();
    });

    window.addEventListener('resize', () => {
      this.toggleScrollShadows();
    });

    document.addEventListener('appeal-scroll-update', () => {
      this.toggleScrollShadows();
    });
  },

  toggleScrollShadows() {
    const wrapperElement = document.querySelector(this._selectors.wrapperEl);
    const scrollElement = document.querySelector(this._selectors.contentEl);

    this.contentScrollHeight = scrollElement.scrollHeight - scrollElement.offsetHeight;

    if (this.contentScrollHeight <= 0) {
      wrapperElement.classList.remove('scroll-shadow--top');
      wrapperElement.classList.remove('scroll-shadow--bottom');
      return;
    }

    const currentScroll = scrollElement.scrollTop / (this.contentScrollHeight);

    if (currentScroll === 0) {
      wrapperElement.classList.remove('scroll-shadow--top');
    } else if (currentScroll === 1) {
      wrapperElement.classList.remove('scroll-shadow--bottom');
    }

    if (currentScroll > 0) {
      wrapperElement.classList.add('scroll-shadow--top');
    } else {
      wrapperElement.classList.add('scroll-shadow--bottom');
    }
  }
};

export default ScrollShadow;